<!-- <section class="banner-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="banner-content">
                            <h1>Trusted Effective Service and Solutions</h1>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, et sed do eiusmod tempor
                                incididunt labore dolore magna aliqua. Quis ipsum suspendisse.</p>
                            <div class="banner-btn">
                                <a routerLink="/contact" class="box-btn">Contact Us</a>
                                <a routerLink="/about" class="box-btn border-btn">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section> -->
<section class="slider-area-2">
    <div class="home-slider">
        <owl-carousel-o [options]="homeSlides">
            <ng-template carouselSlide>
                <div class="single-slider single-slider-bg-1">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="row justify-content-center text-center">
                                    <div class="col-lg-12">
                                        <div class="slider-content one" style="margin: 0px;">

                                            <!-- Main Heading -->
                                            <h2
                                                style="color: #302480; font-size: 28px; font-weight: 600; margin-bottom: 10px; text-align: center;animation: 1.5s 0.3s fadeInUpBig both;">
                                                Welcome to
                                            </h2>
                                            <h1
                                                style="color: #302480; font-size: 48px; font-weight: 700; margin-bottom: 15px; text-align: center;">
                                                Sri Bala Sai Degree College
                                            </h1>

                                            <!-- Silver Jubilee Highlight -->
                                            <h5
                                                style="color: #C12020; font-size: 20px; font-weight: 700; margin-bottom: 8px; text-align: center;animation: 1.5s 0.3s fadeInUpBig both;">
                                                🎉 Silver Jubilee Year
                                            </h5>
                                            <p
                                                style="color: #C12020; font-size: 18px; font-weight: 600; margin-bottom: 18px; text-align: center;">
                                                Proudly Educating Since 2000 – Celebrating 25 Years of Academic
                                                Excellence!
                                            </p>

                                            <!-- Subheading / Tagline -->
                                            <h4
                                                style="font-size: 22px; color: #302480; font-weight: 600; margin-bottom: 10px; text-align: center;animation: 1.5s 0.3s fadeInUpBig both;">
                                                Machilipatnam’s First & Finest Private Degree College Since 2000
                                            </h4>
                                            <p
                                                style="color: #212529; font-size: 18px; margin-bottom: 20px; text-align: center;">
                                                Empowering futures with quality education, smart technology, and
                                                <strong>100% placement assurance</strong>.
                                            </p>

                                            <!-- Highlights List -->
                                            <div class="slider-btn">
                                                <ul
                                                    style="animation: 1.5s 0.3s fadeInUpBig both; color: #212529; font-size: 16px; text-align: center; list-style: none; padding: 0;">
                                                    <li><i class="flaticon-correct"></i> <strong>25 Years</strong> of
                                                        Excellence</li>
                                                    <li><i class="flaticon-correct"></i> <strong>900+ Students</strong>
                                                        Enrolled</li>
                                                    <li><i class="flaticon-correct"></i> <strong>60+ Faculty</strong>
                                                        Committed to Your Growth</li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

           <!-- Slide 2: CRT & Placements -->
<ng-template carouselSlide>
  <div class="single-slider single-slider-bg-2">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-lg-12">
              <div class="slider-content one" style="float: right;">
                <h1 style="font-size: 36px;  font-weight: 700; margin-bottom: 20px;">
                  100% Placement Assurance | Day-One CRT Training
                </h1>
                <p style="font-size: 18px;  margin-bottom: 20px;">
                  We are the pioneers of Campus Recruitment Training in Machilipatnam.<br>
                  Our students are placed in <strong>TCS, Infosys, Wipro, Deloitte, Accenture, Capgemini</strong> & more!
                </p>
                <ul style="list-style: none; padding: 0;  font-size: 18px;">
                  <li>🎯 Training from Day 1</li>
                  <li>🎯 Top MNC Placements</li>
                  <li>🎯 Real-world Industry Readiness</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Slide 3: Scholarships -->
<ng-template carouselSlide>
  <div class="single-slider single-slider-bg-3">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-lg-12">
              <div class="slider-content one">
                <h1 style="font-size: 28px; color: #051242; font-weight: 700; margin-bottom: 20px;">
                  Education for All – 100% Scholarships Available
                </h1>
                <p style="font-size: 18px; color: #212529; margin-bottom: 20px;">
                  Students from <strong>BC, OBC, SC, ST, and minority categories</strong> can avail full scholarships through Andhra Pradesh Government schemes.
                </p>
                <p style="font-size: 18px; color: #212529; font-weight: 500;">
                  💰 No Financial Barriers &nbsp; | &nbsp; 📚 Accessible Higher Education &nbsp; | &nbsp; 🏆 Merit + Support = Success
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Slide 4: Smart Campus -->
<ng-template carouselSlide>
  <div class="single-slider single-slider-bg-4">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-lg-12">
              <div class="slider-content one">
                <h1 style="font-size: 32px;  font-weight: 700; margin-bottom: 20px;">
                  Smart Campus with Face Biometric Attendance
                </h1>
                <p style="font-size: 18px;  margin-bottom: 20px;">
                  Your safety is our priority. Real-time entry alerts sent to parents.<br>
                  Track everything via our Student App – academics, attendance & more!
                </p>
                <ul style="list-style: none; padding: 0; font-size: 18px; ">
                  <li>📲 Instant Notifications to Parents</li>
                  <li>📱 Student App for Daily Updates</li>
                  <li>🔐 Safe & Transparent Learning</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Slide 5: Future-Ready Courses -->
<ng-template carouselSlide>
  <div class="single-slider single-slider-bg-5">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-lg-12">
              <div class="slider-content one"  style="float: left;">
                <h1 style="font-size: 30px; color: #051242; font-weight: 700; margin-bottom: 20px;">
                  Choose a Future-Ready Course
                </h1>
                <p style="font-size: 18px; color: #212529; margin-bottom: 20px;">
                  Explore in-demand UG programs designed for the tech-driven world.
                </p>
                <ul style="list-style: none; padding: 0; font-size: 18px; color: #212529; text-align: left; display: inline-block;">
                  <li>🎓 B.Sc (Computer Science, Data Science, AI)</li>
                  <li>🎓 B.Com (General, Computers)</li>
                  <li>🎓 BBA</li>
                  <li>💼 Skill-based, Job-Ready Curriculum</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

        </owl-carousel-o>
    </div>
</section>

<section class="client-area ptb-100 bg-color">
    <div class="container">
        <div class="section-title">
            <span>Testimonials</span>
            <h2>What Our Client’s Say</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. A facilis vel consequatur tempora atque
                blanditiis exercitationem incidunt, alias corporis quam assumenda dicta.</p>
        </div>
        <div class="client-wrap">
            <owl-carousel-o [options]="clientWrap">
                <ng-template carouselSlide *ngFor="let video of collegeVideos; let i = index">
                    <div class="single-client">
                        <!-- <video src="assets/videos/WhatsApp Video 2025-04-26 at 10.48.51_1d5f3ffa.mp4" autoplay muted
                            loop playsinline controls>
                        </video> -->
                        <video #videoPlayer [src]="video.video" muted loop playsinline controls
                            style="width: 100%; max-height: 500px;">
                        </video>

                        <!-- Custom Play Button -->
                        <!-- <button (click)="playVideo(videoRefs.toArray()[i])" style="
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          transform: translate(-50%, -50%);
                          background: rgba(0,0,0,0.5);
                          border: none;
                          border-radius: 50%;
                          width: 60px;
                          height: 60px;
                          color: white;
                          font-size: 24px;
                          cursor: pointer;
                        ">
                            ▶
                        </button> -->
                    </div>
                </ng-template>
                <!-- <ng-template carouselSlide>
                    <div class="single-client">
                        <video src="assets/videos/WhatsApp Video 2025-04-26 at 10.49.13_7f7d98f9.mp4" autoplay muted
                            loop playsinline controls>
                        </video>
                    </div>
                </ng-template> -->
            </owl-carousel-o>
        </div>
    </div>
</section>


<section class="home-team-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Team Members</span>
            <h2>People Who are Behind the Achievements</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Quis ipsum suspendisse.</p>
        </div>
        <div class="home-team-slider">
            <owl-carousel-o [options]="teamSlides">
                <ng-template carouselSlide *ngFor="let member of studentVideos">
                    <div class="single-team">
                        <div class="team-media">
                            <!-- <img *ngIf="member.type === 'image'" [src]="member.src" [alt]="member.name" /> -->
                            <video [src]="member.video" controls width="100%" height="500px"></video>
                        </div>
                        <div class=" text-center">
                            <h3 style="color: #051242;padding: 20px;background-color: #f5faff;position: relative;">{{
                                member.title }}</h3>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>

            <!-- <owl-carousel-o [options]="teamSlides">
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t1.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>John Smith</h3>
                            <p>Full Stack Developer</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t2.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>Evana Doe</h3>
                            <p>Web Developer</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t3.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>Bread Mc</h3>
                            <p>IT Consulting</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t4.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>Maria Fread</h3>
                            <p>UI/UX Designer</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t1.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>John Smith</h3>
                            <p>Full Stack Developer</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t2.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>Evana Doe</h3>
                            <p>Web Developer</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t3.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>Bread Mc</h3>
                            <p>IT Consulting</p>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team">
                        <div class="team-img">
                            <img src="assets/images/team/t4.jpg" alt="team" />
                        </div>
                        <div class="content text-center">
                            <h3>Maria Fread</h3>
                            <p>UI/UX Designer</p>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o> -->
        </div>
    </div>
</section>